import React from 'react';
import { useUserAndGameContext } from '../../../contexts/UserAndGameContext';
import { useGolfLeagueContext } from '../context/GolfLeagueContext';
import { Box, Typography, Container } from '@mui/material';
import EventsCard from './EventsCard';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const EventsPage = () => {
    const { events } = useGolfLeagueContext();
    const { masterPoolData } = useUserAndGameContext();

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const eventsPageInfo = masterPoolData?.pageInfo?.events;
    //console.log("EventsPageInfo", eventsPageInfo);

    const pageTitle = eventsPageInfo?.pageTitle || "The Events";
    const textColor = eventsPageInfo?.textColor || "#002129";
    const bottomLogo = eventsPageInfo?.bottomLogo;

    return (
        <Container 
            maxWidth={false}
            sx={{ 
                px: { xs: 2, md: 3 },
                maxWidth: '1200px' // Large enough to accommodate the cards at their natural size
            }}
        >
            <Typography
                sx={{
                    fontSize: '40px',
                    fontWeight: '800',
                    margin: '24px 0',
                    textAlign: 'center',
                    color: textColor,
                }}
            >
                {pageTitle}
            </Typography>

            {/* Centered flexbox layout with fixed gap */}
            {events && events.length > 0 ? (
                <Box 
                    sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: 'center',
                        gap: '4px', // Fixed 32px gap between cards
                        mb: 4
                    }}
                >
                    {events.map((event, index) => (
                        <Box
                            key={event.tournamentId || index}
                            sx={{
                                width: isMobile ? '100%' : 'calc((100% - 32px) / 2)', // Divide remaining space evenly
                                maxWidth: isMobile ? 'none' : '450px', // Limit maximum card width
                                minWidth: isMobile ? 'none' : '300px', // Ensure reasonable minimum width
                            }}
                        >
                            <EventsCard 
                                event={event}
                            />
                        </Box>
                    ))}
                </Box>
            ) : (
                <Typography textAlign="center" sx={{ my: 3 }}>
                    No events available at this time.
                </Typography>
            )}

            {bottomLogo && (
                <Box
                    sx={{
                        width: '160px',
                        height: 'auto',
                        margin: '0 auto',
                        padding: '16px 0px',
                    }}
                >
                    <img
                        src={bottomLogo}
                        alt="Bottom Logo"
                        style={{
                            width: '100%',
                            height: 'auto',
                            display: 'block',
                            margin: '0 auto',
                        }}
                    />
                </Box>
            )}
        </Container>
    );
}

export default EventsPage;